export class VdsEvent extends CustomEvent {
    constructor(type, eventInit = {}) {
        super(type, eventInit);
        this.originalEvent = eventInit.originalEvent;
        // 🚨 The following is for iOS <14 since events are constructed with `Event.initEvent()`.
        // eslint-disable-next-line no-prototype-builtins
        if (!this.hasOwnProperty('originEvent')) {
            Object.defineProperties(this, {
                originEvent: {
                    get() {
                        var _a;
                        return (_a = getOriginEvent(this)) !== null && _a !== void 0 ? _a : this;
                    }
                },
                isOriginTrusted: {
                    get() {
                        var _a, _b;
                        return (_b = (_a = getOriginEvent(this)) === null || _a === void 0 ? void 0 : _a.isTrusted) !== null && _b !== void 0 ? _b : false;
                    }
                }
            });
        }
    }
    /**
     * Walks up the event chain (following each `originalEvent`) and returns the origin event
     * that started the chain.
     */
    get originEvent() {
        var _a;
        return (_a = getOriginEvent(this)) !== null && _a !== void 0 ? _a : this;
    }
    /**
     * Walks up the event chain (following each `originalEvent`) and determines whether the initial
     * event was triggered by the end user (ie: check whether `isTrusted` on the `originEvent` `true`).
     */
    get isOriginTrusted() {
        var _a, _b;
        return (_b = (_a = this.originEvent) === null || _a === void 0 ? void 0 : _a.isTrusted) !== null && _b !== void 0 ? _b : false;
    }
}
/**
 * Walks up the event chain (following each `originalEvent`) and returns the origin event
 * that started the chain.
 *
 * @param event
 */
export function getOriginEvent(event) {
    let originalEvent = event.originalEvent;
    while (originalEvent && originalEvent.originalEvent) {
        originalEvent = originalEvent.originalEvent;
    }
    return originalEvent;
}
export function redispatchEvent(target, event) {
    var _a;
    if (event.bubbles && event.composed)
        return;
    const newEvent = new VdsEvent(event.type, {
        originalEvent: (_a = event.originalEvent) !== null && _a !== void 0 ? _a : event,
        detail: event.detail,
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        composed: event.composed
    });
    target.dispatchEvent(newEvent);
}
/**
 * Helps build a `VdsEvent` with type safety.
 *
 * @param type
 * @param eventInit
 */
export function vdsEvent(type, eventInit = {}) {
    return new VdsEvent(type, eventInit);
}
/**
 * Listens to an event on the given `target` and returns a cleanup function to stop listening.
 *
 * @param target - The target to listen for the events on.
 * @param type - The name of the event to listen to.
 * @param listener - The function to be called when the event is fired.
 * @param options - Configures the event listener.
 * @returns Stop listening cleanup function.
 * @example
 * ```ts
 * const disposeListener = listen(window, 'resize', () => {});
 *
 * // Stop listening.
 * disposeListener();
 * ```
 */
export function listen(target, type, listener, options) {
    target.addEventListener(type, listener, options);
    return () => {
        target.removeEventListener(type, listener, options);
    };
}
export function isPointerEvent(event) {
    var _a;
    return (_a = event === null || event === void 0 ? void 0 : event.type.includes('pointer')) !== null && _a !== void 0 ? _a : false;
}
export function isVdsEvent(event) {
    var _a;
    // eslint-disable-next-line no-prototype-builtins
    return (_a = event === null || event === void 0 ? void 0 : event.hasOwnProperty('originalEvent')) !== null && _a !== void 0 ? _a : false;
}
